import type {
  AutoConfiguratorState,
  LineItem,
  LineItemValueId,
  Value,
} from '@snap-types/models/auto-configurator/state';

export function getLineItem(
  state: AutoConfiguratorState,
  lineItemUuid: string,
): LineItem {
  const lineItem = state.lineItems[lineItemUuid];

  if (!lineItem) {
    throw new Error(`Line item not found with UUID: "${lineItemUuid}"`);
  }

  return lineItem;
}

export function getLineItemFromValueId(
  state: AutoConfiguratorState,
  valueId: LineItemValueId,
): LineItem {
  return getLineItem(state, valueId.uuid);
}

export function getLineItemValue(
  state: AutoConfiguratorState,
  valueId: LineItemValueId,
): Value {
  const { uuid, key } = valueId;

  const lineItem = getLineItem(state, uuid);

  return lineItem[key];
}
